module.exports = __webpack_public_path__ + "img/w.c94f850c.png";